import { createContext } from 'react';
import { IDealPricesContext } from './useDealPrices';

export const PricesContext = createContext<IDealPricesContext>({
  depositValue: null,
  servicePlanValue: null,
  partExchangeValue: null,
  setDeposit: () => null,
  setPartExchange: () => null,
  setServicePlan: () => null,
});
